import { OutboundLink } from 'react-ga'
import styled from 'styled-components'
import { Image } from '../../common/style/components/image'
import { mobile } from '../../common/style/media-queries'
import { cseTopPickAttrs } from './resources/cse-top-pick-circle-2019'

export const CseLogo = () => {
  return (
    <StyledOutboundLink
      target="_blank"
      rel="noopener noreferrer"
      to="https://www.commonsense.org/education/website/lalilo"
      eventLabel="common_sense_logo_clicked"
    >
      <StyledImage alt={'CSE Top Pick Circle 2019'} {...cseTopPickAttrs} />
    </StyledOutboundLink>
  )
}

const StyledOutboundLink = styled(OutboundLink)`
  position: absolute;
  top: 45px;
  right: 45px;
  padding: 2px;
  border-radius: 50%;

  @media ${mobile} {
    top: 5px;
    right: 5px;
    width: 60px;
  }
`

const StyledImage = styled(Image)`
  @media ${mobile} {
    width: 60px;
  }
`
